import { Button, Group, Tabs, Text } from '@mantine/core';
import { IconUserPlus } from '@tabler/icons-react';
import { createFileRoute, Link, LoaderFnContext } from '@tanstack/react-router';
import { ActiveUserList } from '@/routes/_main/tenant/users/-components/ActiveUserList';
import { InvitationList } from '@/routes/_main/tenant/users/-components/InvitationList';
import { PageHeader } from '@/components/PageHeader';
import { MyRouterContext } from '@/App';
import { MainContainer } from '@/components/MainContainer';
import { PendingInitialize } from '@/components/PendingInitialize';

export const Route = createFileRoute('/_main/tenant/users/')({
  loader,
  component: Component,
  pendingComponent: () => <PendingInitialize title="ユーザ管理" />,
});

async function loader({
  context: { adminClient, userInfo },
}: LoaderFnContext<Record<never, string>, never, MyRouterContext>) {
  const users = await adminClient.settings_v1_get_users().then((res) => res.items);
  const invitations = await adminClient.admin_v1_get_invitations().then((res) => res.items);
  return {
    adminClient,
    userInfo,
    users,
    invitations,
  };
}

function Component() {
  const { adminClient, userInfo, users, invitations } = Route.useLoaderData();

  return (
    <MainContainer>
      <PageHeader
        title="ユーザ管理"
        description="新規ユーザへの招待メールの送信、権限の変更、およびユーザ削除を行います。"
      />
      <Text size="xs">※ 権限の変更が反映されるまで、最長で10分程度かかる場合があります。</Text>
      <Group justify="end">
        <Link from={Route.fullPath} to="./send-invitation">
          <Button
            color="blue"
            size="sm"
            leftSection={<IconUserPlus style={{ width: '70%', height: '70%' }} />}
          >
            招待メールを送る
          </Button>
        </Link>
      </Group>
      <Tabs defaultValue="users" variant="outline">
        <Tabs.List>
          <Tabs.Tab value="users">ユーザ一覧</Tabs.Tab>
          <Tabs.Tab value="invitations">承認待ち一覧</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="users" className="py-5">
          <ActiveUserList users={users} userInfo={userInfo} adminClient={adminClient} />
        </Tabs.Panel>
        <Tabs.Panel value="invitations" className="py-5">
          <InvitationList invitations={invitations} adminClient={adminClient} />
        </Tabs.Panel>
      </Tabs>
    </MainContainer>
  );
}
